export const FETCH_DIALOG_BADGES_FAILED = "error:dialogs.fetch-dialog-badges-failed"
export const FETCH_CURRENT_DIALOG_FAILED = "error:dialogs.fetch-current-dialog-failed"
export const FETCH_DIALOG_MESSAGES_FAILED = "error:dialogs.fetch-dialog-messages-failed"
export const FETCH_CLIENT_SURVEY_FAILED = "error:dialogs.fetch-client-survey-failed"

export const SEND_MESSAGE_FAILED = "error:dialogs.send-message-failed"
export const DELETE_MESSAGE_FAILED = "error:dialogs.delete-message-failed"
export const EDIT_MESSAGE_FAILED = "error:dialogs.delete-message-failed"
